import { IMAGE_BASE_URL_OF_USER } from '../constants';
import axios from 'axios';
import { useCallback, useRef } from 'react';
import type { Crop } from 'react-image-crop';
import Rank_No_1 from '../../src/assets/images/ranking_number_order/Ranking_No1.png';
import Rank_No_2 from '../../src/assets/images/ranking_number_order/Ranking_No2.png';
import Rank_No_3 from '../../src/assets/images/ranking_number_order/Ranking_No3.png';
import Rank_No_4 from '../../src/assets/images/ranking_number_order/Ranking_No4.png';
import Rank_No_5 from '../../src/assets/images/ranking_number_order/Ranking_No5.png';
import Rank_No_6 from '../../src/assets/images/ranking_number_order/Ranking_No6.png';
import Rank_No_7 from '../../src/assets/images/ranking_number_order/Ranking_No7.png';
import Rank_No_8 from '../../src/assets/images/ranking_number_order/Ranking_No8.png';
import Rank_No_9 from '../../src/assets/images/ranking_number_order/Ranking_No9.png';
import Rank_No_10 from '../../src/assets/images/ranking_number_order/Ranking_No10.png';

// import Title_Month_1 from '../../src/assets/images/ranking_title/Title thang 1.png';
// import Title_Month_2 from '../../src/assets/images/ranking_title/Title thang 2.png';
// import Title_Month_3 from '../../src/assets/images/ranking_title/Title thang 3.png';
// import Title_Month_4 from '../../src/assets/images/ranking_title/Title thang 4.png';
// import Title_Month_5 from '../../src/assets/images/ranking_title/Title thang 5.png';
// import Title_Month_6 from '../../src/assets/images/ranking_title/Title thang 6.png';
// import Title_Month_7 from '../../src/assets/images/ranking_title/Title thang 7.png';
// import Title_Month_8 from '../../src/assets/images/ranking_title/Title thang 8.png';
// import Title_Month_9 from '../../src/assets/images/ranking_title/Title thang 9.png';
// import Title_Month_10 from '../../src/assets/images/ranking_title/Title thang 10.png';
// import Title_Month_11 from '../../src/assets/images/ranking_title/Title thang 11.png';
// import Title_Month_12 from '../../src/assets/images/ranking_title/Title thang 12.png';

import Title_Month_1 from '../../src/assets/images/ranking_title_2026/1-2026.png';
import Title_Month_2 from '../../src/assets/images/ranking_title_2026/2-2026.png';
import Title_Month_3 from '../../src/assets/images/ranking_title_2026/3-2026.png';
import Title_Month_4 from '../../src/assets/images/ranking_title_2026/4-2026.png';
import Title_Month_5 from '../../src/assets/images/ranking_title_2026/5-2026.png';
import Title_Month_6 from '../../src/assets/images/ranking_title_2026/6-2026.png';
import Title_Month_7 from '../../src/assets/images/ranking_title_2026/7-2026.png';
import Title_Month_8 from '../../src/assets/images/ranking_title_2026/8-2026.png';
import Title_Month_9 from '../../src/assets/images/ranking_title_2026/9-2026.png';
import Title_Month_10 from '../../src/assets/images/ranking_title_2026/10-2026.png';
import Title_Month_11 from '../../src/assets/images/ranking_title_2026/11-2026.png';
import Title_Month_12 from '../../src/assets/images/ranking_title_2026/12-2026.png';

import Title_Split_Month_1 from '../../src/assets/images/ranking_title_split_2026/Month_01.png';
import Title_Split_Month_2 from '../../src/assets/images/ranking_title_split_2026/Month_02.png';
import Title_Split_Month_3 from '../../src/assets/images/ranking_title_split_2026/Month_03.png';
import Title_Split_Month_4 from '../../src/assets/images/ranking_title_split_2026/Month_04.png';
import Title_Split_Month_5 from '../../src/assets/images/ranking_title_split_2026/Month_05.png';
import Title_Split_Month_6 from '../../src/assets/images/ranking_title_split_2026/Month_06.png';
import Title_Split_Month_7 from '../../src/assets/images/ranking_title_split_2026/Month_07.png';
import Title_Split_Month_8 from '../../src/assets/images/ranking_title_split_2026/Month_08.png';
import Title_Split_Month_9 from '../../src/assets/images/ranking_title_split_2026/Month_09.png';
import Title_Split_Month_10 from '../../src/assets/images/ranking_title_split_2026/Month_10.png';
import Title_Split_Month_11 from '../../src/assets/images/ranking_title_split_2026/Month_11.png';
import Title_Split_Month_12 from '../../src/assets/images/ranking_title_split_2026/Month_12.png';

// update 17/4/2026
import Ranking_Appointee_Title_Month_1 from '../../src/assets/images/ranking_title/appointee/Ranking_Appointee_Title_Month_1.png';
import Ranking_Appointee_Title_Month_2 from '../../src/assets/images/ranking_title/appointee/Ranking_Appointee_Title_Month_2.png';
import Ranking_Appointee_Title_Month_3 from '../../src/assets/images/ranking_title/appointee/Ranking_Appointee_Title_Month_3.png';
import Ranking_Appointee_Title_Month_4 from '../../src/assets/images/ranking_title/appointee/Ranking_Appointee_Title_Month_4.png';
import Ranking_Appointee_Title_Month_5 from '../../src/assets/images/ranking_title/appointee/Ranking_Appointee_Title_Month_5.png';
import Ranking_Appointee_Title_Month_6 from '../../src/assets/images/ranking_title/appointee/Ranking_Appointee_Title_Month_6.png';
import Ranking_Appointee_Title_Month_7 from '../../src/assets/images/ranking_title/appointee/Ranking_Appointee_Title_Month_7.png';
import Ranking_Appointee_Title_Month_8 from '../../src/assets/images/ranking_title/appointee/Ranking_Appointee_Title_Month_8.png';
import Ranking_Appointee_Title_Month_9 from '../../src/assets/images/ranking_title/appointee/Ranking_Appointee_Title_Month_9.png';
import Ranking_Appointee_Title_Month_10 from '../../src/assets/images/ranking_title/appointee/Ranking_Appointee_Title_Month_10.png';
import Ranking_Appointee_Title_Month_11 from '../../src/assets/images/ranking_title/appointee/Ranking_Appointee_Title_Month_11.png';
import Ranking_Appointee_Title_Month_12 from '../../src/assets/images/ranking_title/appointee/Ranking_Appointee_Title_Month_12.png';

import Ranking_Sale_Title_Month_1 from '../../src/assets/images/ranking_title/sales/Ranking_Sale_Title_Month_1.png';
import Ranking_Sale_Title_Month_2 from '../../src/assets/images/ranking_title/sales/Ranking_Sale_Title_Month_2.png';
import Ranking_Sale_Title_Month_3 from '../../src/assets/images/ranking_title/sales/Ranking_Sale_Title_Month_3.png';
import Ranking_Sale_Title_Month_4 from '../../src/assets/images/ranking_title/sales/Ranking_Sale_Title_Month_4.png';
import Ranking_Sale_Title_Month_5 from '../../src/assets/images/ranking_title/sales/Ranking_Sale_Title_Month_5.png';
import Ranking_Sale_Title_Month_6 from '../../src/assets/images/ranking_title/sales/Ranking_Sale_Title_Month_6.png';
import Ranking_Sale_Title_Month_7 from '../../src/assets/images/ranking_title/sales/Ranking_Sale_Title_Month_7.png';
import Ranking_Sale_Title_Month_8 from '../../src/assets/images/ranking_title/sales/Ranking_Sale_Title_Month_8.png';
import Ranking_Sale_Title_Month_9 from '../../src/assets/images/ranking_title/sales/Ranking_Sale_Title_Month_9.png';
import Ranking_Sale_Title_Month_10 from '../../src/assets/images/ranking_title/sales/Ranking_Sale_Title_Month_10.png';
import Ranking_Sale_Title_Month_11 from '../../src/assets/images/ranking_title/sales/Ranking_Sale_Title_Month_11.png';
import Ranking_Sale_Title_Month_12 from '../../src/assets/images/ranking_title/sales/Ranking_Sale_Title_Month_12.png';

import Ranking_Sale_No_1 from '../../src/assets/images/ranking_number_order/sales/Ranking_Sale_No1.png';
import Ranking_Sale_No_2 from '../../src/assets/images/ranking_number_order/sales/Ranking_Sale_No2.png';
import Ranking_Sale_No_3 from '../../src/assets/images/ranking_number_order/sales/Ranking_Sale_No3.png';
import Ranking_Sale_No_4 from '../../src/assets/images/ranking_number_order/sales/Ranking_Sale_No4.png';
import Ranking_Sale_No_5 from '../../src/assets/images/ranking_number_order/sales/Ranking_Sale_No5.png';
import Ranking_Sale_No_6 from '../../src/assets/images/ranking_number_order/sales/Ranking_Sale_No6.png';
import Ranking_Sale_No_7 from '../../src/assets/images/ranking_number_order/sales/Ranking_Sale_No7.png';
import Ranking_Sale_No_8 from '../../src/assets/images/ranking_number_order/sales/Ranking_Sale_No8.png';
import Ranking_Sale_No_9 from '../../src/assets/images/ranking_number_order/sales/Ranking_Sale_No9.png';
import Ranking_Sale_No_10 from '../../src/assets/images/ranking_number_order/sales/Ranking_Sale_No10.png';
import Ranking_Sale_No_11 from '../../src/assets/images/ranking_number_order/sales/Ranking_Sale_No11.png';
import Ranking_Sale_No_12 from '../../src/assets/images/ranking_number_order/sales/Ranking_Sale_No12.png';
import Ranking_Sale_No_13 from '../../src/assets/images/ranking_number_order/sales/Ranking_Sale_No13.png';
import Ranking_Sale_No_14 from '../../src/assets/images/ranking_number_order/sales/Ranking_Sale_No14.png';
import Ranking_Sale_No_15 from '../../src/assets/images/ranking_number_order/sales/Ranking_Sale_No15.png';
import Ranking_Sale_No_16 from '../../src/assets/images/ranking_number_order/sales/Ranking_Sale_No16.png';
import Ranking_Sale_No_17 from '../../src/assets/images/ranking_number_order/sales/Ranking_Sale_No17.png';
import Ranking_Sale_No_18 from '../../src/assets/images/ranking_number_order/sales/Ranking_Sale_No18.png';
import Ranking_Sale_No_19 from '../../src/assets/images/ranking_number_order/sales/Ranking_Sale_No19.png';
import Ranking_Sale_No_20 from '../../src/assets/images/ranking_number_order/sales/Ranking_Sale_No20.png';

import Ranking_Appointee_No_1 from '../../src/assets/images/ranking_number_order/appointee/Ranking_Appointee_No1.png';
import Ranking_Appointee_No_2 from '../../src/assets/images/ranking_number_order/appointee/Ranking_Appointee_No2.png';
import Ranking_Appointee_No_3 from '../../src/assets/images/ranking_number_order/appointee/Ranking_Appointee_No3.png';
import Ranking_Appointee_No_4 from '../../src/assets/images/ranking_number_order/appointee/Ranking_Appointee_No4.png';
import Ranking_Appointee_No_5 from '../../src/assets/images/ranking_number_order/appointee/Ranking_Appointee_No5.png';
import Ranking_Appointee_No_6 from '../../src/assets/images/ranking_number_order/appointee/Ranking_Appointee_No6.png';
import Ranking_Appointee_No_7 from '../../src/assets/images/ranking_number_order/appointee/Ranking_Appointee_No7.png';
import Ranking_Appointee_No_8 from '../../src/assets/images/ranking_number_order/appointee/Ranking_Appointee_No8.png';
import Ranking_Appointee_No_9 from '../../src/assets/images/ranking_number_order/appointee/Ranking_Appointee_No9.png';
import Ranking_Appointee_No_10 from '../../src/assets/images/ranking_number_order/appointee/Ranking_Appointee_No10.png';
import Ranking_Appointee_No_11 from '../../src/assets/images/ranking_number_order/appointee/Ranking_Appointee_No11.png';
import Ranking_Appointee_No_12 from '../../src/assets/images/ranking_number_order/appointee/Ranking_Appointee_No12.png';
import Ranking_Appointee_No_13 from '../../src/assets/images/ranking_number_order/appointee/Ranking_Appointee_No13.png';
import Ranking_Appointee_No_14 from '../../src/assets/images/ranking_number_order/appointee/Ranking_Appointee_No14.png';
import Ranking_Appointee_No_15 from '../../src/assets/images/ranking_number_order/appointee/Ranking_Appointee_No15.png';
import Ranking_Appointee_No_16 from '../../src/assets/images/ranking_number_order/appointee/Ranking_Appointee_No16.png';
import Ranking_Appointee_No_17 from '../../src/assets/images/ranking_number_order/appointee/Ranking_Appointee_No17.png';
import Ranking_Appointee_No_18 from '../../src/assets/images/ranking_number_order/appointee/Ranking_Appointee_No18.png';
import Ranking_Appointee_No_19 from '../../src/assets/images/ranking_number_order/appointee/Ranking_Appointee_No19.png';
import Ranking_Appointee_No_20 from '../../src/assets/images/ranking_number_order/appointee/Ranking_Appointee_No20.png';

import Ranking_Sale_Title_Day from '../../src/assets/images/ranking_title/sales/Ranking_Sale_Title_Day.png';
import Ranking_Appointee_Title_Day from '../../src/assets/images/ranking_title/appointee/Ranking_Appointee_Title_Day.png';

import Ranking_Sale_Subtitle_Top10 from '../../src/assets/images/ranking_sub_title/sales/Ranking_Sale_Subtitle_Top10.png';
import Ranking_Sale_Subtitle_Top20 from '../../src/assets/images/ranking_sub_title/sales/Ranking_Sale_Subtitle_Top20.png';

import Ranking_Appointee_Subtitle_Top10 from '../../src/assets/images/ranking_sub_title/appointee/Ranking_Appointee_Subtitle_Top10.png';
import Ranking_Appointee_Subtitle_Top20 from '../../src/assets/images/ranking_sub_title/appointee/Ranking_Appointee_Subtitle_Top20.png';

export const isValidImageUrl = async (url: any) => {
  try {
    const response = await axios.head(url);
    return response.status >= 200 && response.status < 300;
  } catch (error) {
    return false;
  }
};
export const getTypes = (arr: { name: string }[]): string[] => {
  const hasMonth = arr.some(({ name }) => name.includes('MONTH'));
  const hasDay = arr.some(({ name }) => name.includes('DAY'));

  if (!hasMonth && !hasDay) return [];
  if (hasMonth && !hasDay) return ['month'];
  if (hasDay && !hasMonth) return ['date'];

  const result = arr[0].name.includes('MONTH') ? ['month', 'date'] : ['date', 'month'];

  return result;
};
export const changeArr = (arr1: any[]) => {
  const valueMap: Record<string, number> = {};
  const statusMap: Record<string, number> = {};
  const filteredArr: any[] = [];

  for (const { name, value, status } of arr1) {
    valueMap[name] = value;
    statusMap[name] = status;
  }

  for (const { name } of arr1) {
    if (name.includes('_') && statusMap[name] !== 0 && statusMap[name.split('_')[0]] !== 0) {
      filteredArr.push({ name, data: [] });
    }
  }

  return filteredArr.sort(
    (a, b) =>
      (valueMap[a.name.split('_')[0]] ?? 0) - (valueMap[b.name.split('_')[0]] ?? 0) ||
      (valueMap[a.name] ?? 0) - (valueMap[b.name] ?? 0)
  );
};
// export async function createImage(url: string): Promise<HTMLImageElement> {
//   return new Promise((resolve, reject) => {
//     const image = new Image();
//     image.addEventListener('load', () => resolve(image));
//     image.addEventListener('error', (error) => reject(error));
//     image.setAttribute('crossOrigin', 'anonymous');
//     image.src = url;
//   });
// }
export const createFileFromUrl = async (url: string, fileName: string) => {
  const response = await fetch(url, { mode: 'cors', cache: 'no-cache' });
  const blob = await response.blob();
  return new File([blob], fileName, { type: 'image/jpg' });
};
export const createImage = (url: any): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.onload = () => resolve(image);
    image.onerror = (error) => reject(error);
    image.src = url;
  });

export async function getCroppedImg(
  imageSrc: string,
  pixelCrop: { x: number; y: number; width: number; height: number }
): Promise<string | null> {
  const image = await createImage(imageSrc);
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  if (!ctx) {
    console.error('Canvas context is null');
    return null;
  }

  canvas.width = pixelCrop.width;
  canvas.height = pixelCrop.height;

  ctx.drawImage(
    image,
    pixelCrop.x,
    pixelCrop.y,
    pixelCrop.width,
    pixelCrop.height,
    0,
    0,
    pixelCrop.width,
    pixelCrop.height
  );

  return new Promise((resolve: any) => {
    canvas.toBlob((blob) => resolve(blob), 'image/jpeg');
    // canvas.toBlob((blob) => {
    //   if (blob) {
    //     const url = URL.createObjectURL(blob);
    //     resolve(url);
    //   } else {
    //     resolve(null);
    //   }
    // }, 'image/jpeg');
  });
}

// handle crop video, this function will crop every frame in video and recorded it by MediaRecorder API from JS
export async function getCroppedVideo(
  videoSrc: string,
  pixelCrop: { x: number; y: number; width: number; height: number },
  onProgress?: (percent: number) => void
): Promise<Blob | null> {
  return new Promise((resolve, reject) => {
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Elements/video
    const video = document.createElement('video');
    video.src = videoSrc;
    video.muted = true;
    video.onloadedmetadata = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        console.error('Canvas context is null');
        resolve(null);
        return;
      }

      canvas.width = pixelCrop.width;
      canvas.height = pixelCrop.height;

      // https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/captureStream
      const stream = canvas.captureStream();

      // https://developer.mozilla.org/en-US/docs/Web/API/MediaRecorder
      // https://developer.mozilla.org/en-US/docs/Web/API/MediaStream_Recording_API
      const mediaRecorder = new MediaRecorder(stream, {
        mimeType: 'video/mp4;codecs=vp9',
        videoBitsPerSecond: 2500000,
      });

      const chunks: Blob[] = [];

      mediaRecorder.ondataavailable = (e) => {
        if (e.data.size > 0) {
          chunks.push(e.data);
        }
      };

      mediaRecorder.onstop = () => {
        const blob = new Blob(chunks, { type: 'video/mp4' });
        onProgress?.(100);
        resolve(blob);
      };

      mediaRecorder.onerror = (e) => {
        console.error('MediaRecorder error:', e);
        reject(e);
      };

      mediaRecorder.start();
      const throttledProgress = onProgress ? throttle(onProgress, 1000) : null;
      const drawFrame = () => {
        if (video.ended || video.paused) {
          mediaRecorder.stop();
          return;
        }

        ctx.drawImage(
          video,
          pixelCrop.x,
          pixelCrop.y,
          pixelCrop.width,
          pixelCrop.height,
          0,
          0,
          pixelCrop.width,
          pixelCrop.height
        );
        if (throttledProgress) {
          const percent = Math.min((video.currentTime / video.duration) * 100, 99);
          throttledProgress(percent);
        }
        // https://developer.mozilla.org/en-US/docs/Web/API/Window/requestAnimationFrame
        requestAnimationFrame(drawFrame);
      };

      video.play();
      drawFrame();
    };

    video.onerror = () => {
      console.error('Video loading error');
      reject(new Error('Failed to load video'));
    };
  });
}
// export async function getCroppedImg(imageSrc: string, crop: Area): Promise<Blob | null> {
//   const image = await createImage(imageSrc);
//   const canvas = document.createElement('canvas');
//   const ctx = canvas.getContext('2d');
//   if (!ctx) return null;

//   canvas.width = crop.width;
//   canvas.height = crop.height;

//   ctx.drawImage(
//     image,
//     crop.x,
//     crop.y,
//     crop.width,
//     crop.height,
//     0,
//     0,
//     crop.width,
//     crop.height
//   );
// return new Promise((resolve) => {
//   canvas.toBlob((blob) => {
//     if (blob) {
//       const url: any = URL.createObjectURL(blob);
//       resolve(url);
//     } else {
//       resolve(null); // trả về null nếu toBlob thất bại
//     }
//   }, 'image/jpeg');
// });
//   // return new Promise((resolve) => {
//   //   canvas.toBlob((blob) => resolve(blob), 'image/jpeg');
//   // });
// }

export async function convertImageToBase64(url: any): Promise<string> {
  const response = await fetch(url, { mode: 'cors' }); // nên có cors
  const blob = await response.blob();

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}
export const createLocalImageFromUrl = async (url: string): Promise<string> => {
  const response = await fetch(url, { mode: 'no-cors', cache: 'no-cache' });
  const blob = await response.blob();
  return URL.createObjectURL(blob);
};
export function getCroppedImage(
  image: HTMLImageElement,
  crop: Crop,
  fileName = 'cropped.jpg'
): Promise<File> {
  const canvas = document.createElement('canvas');
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;

  canvas.width = crop.width!;
  canvas.height = crop.height!;

  const ctx = canvas.getContext('2d');
  if (!ctx) throw new Error('Failed to get canvas context');

  ctx.drawImage(
    image,
    crop.x! * scaleX,
    crop.y! * scaleY,
    crop.width! * scaleX,
    crop.height! * scaleY,
    0,
    0,
    crop.width!,
    crop.height!
  );

  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob) return reject('Canvas is empty');
      const file = new File([blob], fileName, { type: 'image/jpeg' });
      resolve(file);
    }, 'image/jpeg');
  });
}
export function useDebounceFn<T extends (...args: any[]) => void>(callback: T, delay = 300): T {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const debouncedFn = useCallback(
    (...args: Parameters<T>) => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        callback(...args);
      }, delay);
    },
    [callback, delay]
  );

  return debouncedFn as T;
}
function throttle<T extends (...args: any[]) => void>(
  func: T,
  delay: number
): (...args: Parameters<T>) => void {
  let lastCall = 0;
  return (...args: Parameters<T>) => {
    const now = Date.now();
    if (now - lastCall >= delay) {
      lastCall = now;
      func(...args);
    }
  };
}

export const generateImage = (img: any) => {
  if (img) {
    return `${IMAGE_BASE_URL_OF_USER}/shop/logo/small/${img}`;
  }
};
export const rgbToHex = (rgb: string): string => {
  if (rgb.startsWith('#')) return rgb.toUpperCase();
  const result = rgb.match(/\d+(\.\d+)?/g);
  if (!result) return rgb;
  const [r, g, b] = result.map(Number);
  // Chuyển sang HEX
  const toHex = (v: number) => v.toString(16).padStart(2, '0').toUpperCase();
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
};
export const rankingNumberOrderStardamGroupTitle: Record<string, string> = {
  'No.1': Rank_No_1,
  'No.2': Rank_No_2,
  'No.3': Rank_No_3,
  'No.4': Rank_No_4,
  'No.5': Rank_No_5,
  'No.6': Rank_No_6,
  'No.7': Rank_No_7,
  'No.8': Rank_No_8,
  'No.9': Rank_No_9,
  'No.10': Rank_No_10,
};
export const rankingNumberOrderStardamGroupTitleNumber: Record<number, string> = {
  1: Rank_No_1,
  2: Rank_No_2,
  3: Rank_No_3,
  4: Rank_No_4,
  5: Rank_No_5,
  6: Rank_No_6,
  7: Rank_No_7,
  8: Rank_No_8,
  9: Rank_No_9,
  10: Rank_No_10,
};
export const monthTitleStardamGroupTitle: Record<number, string> = {
  1: Title_Month_1,
  2: Title_Month_2,
  3: Title_Month_3,
  4: Title_Month_4,
  5: Title_Month_5,
  6: Title_Month_6,
  7: Title_Month_7,
  8: Title_Month_8,
  9: Title_Month_9,
  10: Title_Month_10,
  11: Title_Month_11,
  12: Title_Month_12,
};
export const monthTitleStardamGroupSplit: Record<number, string> = {
  1: Title_Split_Month_1,
  2: Title_Split_Month_2,
  3: Title_Split_Month_3,
  4: Title_Split_Month_4,
  5: Title_Split_Month_5,
  6: Title_Split_Month_6,
  7: Title_Split_Month_7,
  8: Title_Split_Month_8,
  9: Title_Split_Month_9,
  10: Title_Split_Month_10,
  11: Title_Split_Month_11,
  12: Title_Split_Month_12,
};
export const monthAppointeeTitle: Record<number, string> = {
  1: Ranking_Appointee_Title_Month_1,
  2: Ranking_Appointee_Title_Month_2,
  3: Ranking_Appointee_Title_Month_3,
  4: Ranking_Appointee_Title_Month_4,
  5: Ranking_Appointee_Title_Month_5,
  6: Ranking_Appointee_Title_Month_6,
  7: Ranking_Appointee_Title_Month_7,
  8: Ranking_Appointee_Title_Month_8,
  9: Ranking_Appointee_Title_Month_9,
  10: Ranking_Appointee_Title_Month_10,
  11: Ranking_Appointee_Title_Month_11,
  12: Ranking_Appointee_Title_Month_12,
};
export const monthSaleTitle: Record<number, string> = {
  1: Ranking_Sale_Title_Month_1,
  2: Ranking_Sale_Title_Month_2,
  3: Ranking_Sale_Title_Month_3,
  4: Ranking_Sale_Title_Month_4,
  5: Ranking_Sale_Title_Month_5,
  6: Ranking_Sale_Title_Month_6,
  7: Ranking_Sale_Title_Month_7,
  8: Ranking_Sale_Title_Month_8,
  9: Ranking_Sale_Title_Month_9,
  10: Ranking_Sale_Title_Month_10,
  11: Ranking_Sale_Title_Month_11,
  12: Ranking_Sale_Title_Month_12,
};

export const saleNoOrder: Record<number, string> = {
  1: Ranking_Sale_No_1,
  2: Ranking_Sale_No_2,
  3: Ranking_Sale_No_3,
  4: Ranking_Sale_No_4,
  5: Ranking_Sale_No_5,
  6: Ranking_Sale_No_6,
  7: Ranking_Sale_No_7,
  8: Ranking_Sale_No_8,
  9: Ranking_Sale_No_9,
  10: Ranking_Sale_No_10,
  11: Ranking_Sale_No_11,
  12: Ranking_Sale_No_12,
  13: Ranking_Sale_No_13,
  14: Ranking_Sale_No_14,
  15: Ranking_Sale_No_15,
  16: Ranking_Sale_No_16,
  17: Ranking_Sale_No_17,
  18: Ranking_Sale_No_18,
  19: Ranking_Sale_No_19,
  20: Ranking_Sale_No_20,
};

export const appointeeNoOrder: Record<number, string> = {
  1: Ranking_Appointee_No_1,
  2: Ranking_Appointee_No_2,
  3: Ranking_Appointee_No_3,
  4: Ranking_Appointee_No_4,
  5: Ranking_Appointee_No_5,
  6: Ranking_Appointee_No_6,
  7: Ranking_Appointee_No_7,
  8: Ranking_Appointee_No_8,
  9: Ranking_Appointee_No_9,
  10: Ranking_Appointee_No_10,
  11: Ranking_Appointee_No_11,
  12: Ranking_Appointee_No_12,
  13: Ranking_Appointee_No_13,
  14: Ranking_Appointee_No_14,
  15: Ranking_Appointee_No_15,
  16: Ranking_Appointee_No_16,
  17: Ranking_Appointee_No_17,
  18: Ranking_Appointee_No_18,
  19: Ranking_Appointee_No_19,
  20: Ranking_Appointee_No_20,
};

export const daySaleTitle = Ranking_Sale_Title_Day;
export const dayAppointeeTitle = Ranking_Appointee_Title_Day;

export const saleSubtitleTop10 = Ranking_Sale_Subtitle_Top10;
export const saleSubtitleTop20 = Ranking_Sale_Subtitle_Top20;

export const appointeeSubtitleTop10 = Ranking_Appointee_Subtitle_Top10;
export const appointeeSubtitleTop20 = Ranking_Appointee_Subtitle_Top20;

export const isVideo = (item: any) =>
  typeof item?.link === 'string' && item.link.toLowerCase().endsWith('.mp4');

export const isImage = (item: any) => {
  const link = item?.link?.toLowerCase() || '';
  return (
    link.endsWith('.jpg') ||
    link.endsWith('.jpeg') ||
    link.endsWith('.png') ||
    link.endsWith('.webp')
  );
};
export async function wait(ms = 1000) {
  await new Promise((resolve) => setTimeout(resolve, ms));
}

// https://coreui.io/blog/how-to-conditionally-add-a-property-to-an-object-in-javascript/
export const conditionalAddPropertyIntoObject = (
  obj: any,
  key: string,
  value: any,
  condition: any
) => {
  return condition ? { ...obj, [key]: value } : obj;
};
